export default __webpack_public_path__ + "static/media/lockIcon.d81d88e7.png";